// extracted by mini-css-extract-plugin
export default {"anotherSaleBtn":"IconButtons_anotherSaleBtn__Ekw6-","iconBtn":"IconButtons_iconBtn__hwE36","addIcon":"IconButtons_addIcon__j98Dc"};